module.exports = __webpack_public_path__ + "img/heatmap.4a243efe.svg";